export default "__VITE_ASSET__Csy_WuQ4__"